import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router";

/**
 * Start a page the reader has just opened at its top.
 *
 * On a narrow screen the document itself scrolls, and nothing resets it between
 * routes, so opening an album from far down the home page landed the reader
 * part-way through its tracklist. A wide screen scrolls inside each page, which
 * is new and so already at its top; there the call does nothing.
 *
 * Only a navigation forward. Going back (`POP`) is the browser's to restore, and
 * the first render is a `POP` as well, so a page loaded directly is left alone.
 *
 * A layout effect, so the scroll lands in the same commit as the new page and a
 * view transition's picture of that page is taken at its top rather than
 * wherever the last page was left.
 */
export const useScrollToTopOnNavigation = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === "POP") {
      return;
    }
    window.scrollTo({ behavior: "instant", left: 0, top: 0 });
  }, [navigationType, pathname]);
};
